import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleFetchScheduleHistoryData = (
  siteId: string,
  setScheduleHistoryData: Dispatcher<any[]>,
  setFetchingScheduleHistoryData: Dispatcher<boolean>,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleFetchScheduleHistoryData(
      siteId,
      setScheduleHistoryData,
      setFetchingScheduleHistoryData,
      navigate
    );
  };

  // consolidated=true (ED-14): one entry per save with per-day changes,
  // instead of the raw replace-the-week history rows.
  AxiosUI.get(`schedule/history/?customer__id=${siteId}&consolidated=true`).then(
    (response: AxiosResponse) => {
      const results = response.data.results ?? [];
      setScheduleHistoryData(results);
      setFetchingScheduleHistoryData(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setFetchingScheduleHistoryData(false);
      });
    }
  );
};
